module.exports = __webpack_public_path__ + "static/media/camping-02.f39d0616.jpg";